"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBDMenuToggleOption = void 0;
const FBDMenuSelectOption_1 = require("./FBDMenuSelectOption");
class FBDMenuToggleOption extends FBDMenuSelectOption_1.FBDMenuSelectOption {
    constructor(prefix, description, callback, on) {
        super(prefix, ["N", "Y"], [description, description], (idx) => {
            this.on = idx == 1;
            if (callback)
                callback(idx);
        }, on ? 1 : 0);
        this.on = on;
    }
}
exports.FBDMenuToggleOption = FBDMenuToggleOption;
